// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container__tag .custom__tags[data-v-c38792d2] {\n  font-size: 14.4px;\n}\n[data-v-c38792d2] .b-form-tag-content {\n  font-size: 13px !important;\n}\n[data-v-c38792d2] button.btn.b-form-tags-button.py-0.btn-outline-secondary {\n  width: 65px;\n}\n[data-v-c38792d2] .disabled_cursor input#tags-validation {\n  cursor: not-allowed;\n}", ""]);
// Exports
module.exports = exports;
